<div class="ikonaKontextoveNapovedy">
	<a (click)="pripravitNapoveduAOtevritModal($event)">
		<mat-icon color="primary">info</mat-icon>
	</a>
</div>
